module.exports = __webpack_public_path__ + "static/media/dashboard-digitalize-gift.1e99e2c1.svg";